import React from 'react';
import type ProjectSettingsServiceDeskPortalSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskClassicPortalSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskPortalSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-classic-portal-settings", jiraSpaEntry: "async-project-settings-service-desk-classic-portal-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskClassicPortalSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskClassicPortalSettings}
		pageId="project-settings-classic-portal-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskClassicPortalSettings;
